<template>
  <div class="card_bg" @click="onClick" :style="cardStatus">
    <div class="card_content">
      <div>
        <div class="checkbox" :style="checkBoxStatus"/>
      </div>
      <div class="text_content">
        <div class="text1">
          {{ record.text1 }}
        </div>
        <div class="text2">
          {{ record.text2 }}
        </div>
      </div>
    </div>

    <div class="text3">
      {{ formattedPrice }}
    </div>
  </div>
</template>
    
    <script>
export default {
  props: ["record"],
  data() {
    return {};
  },
  computed: {
    formattedPrice() {
      return this.record.price.toLocaleString() + "원";
    },
    checkBoxStatus() {
      if(this.record.selected)
        return {
          background: '#215FE6',
          border: '1px solid #215FE6',
        };
      else 
        return {
          background: '#f8f9fa',
          border: '1px solid #d7d7d7',
        };
    },
    cardStatus() {
      if(this.record.selected)
        return {
          background: '#215FE608',
          border: '1px solid #215FE6',
        };
      else 
        return {
          background: '#F8F9FA',
          border: '1px solid #d7d7d7',
        };
    },
  },

  methods: {
    onClick() {
      this.record.selected = !this.record.selected
      this.$emit("select", this.record);
    },
  },
};
</script>
    
  <style scoped>
.bg {
  display: flex;
  justify-content: center;
  text-align: center;
}
.caption {
  width: fit-content;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
}
.card_bg {
  position:relative;
  padding: 15px;
  text-align: left;
  width: 288px;
  height: 142px;
  border-radius: 16px;
  overflow: hidden;
  cursor:pointer;
}

.card_content {
  overflow: hidden;
  display: flex;
}

.checkbox {
  margin-top: 5px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.text_content {
  margin-left: 10px;
  display: "block";
}

.text1 {
  color: #000000;
  font-size: 20px;
  font-weight: 700;
}
.text2 {
  color: #555555;
  font-size: 16px;
  font-weight: 500;
}
.text3 {
  position: absolute;
  height: fit-content;
  right: 15px;
  bottom: 15px;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  text-align: right;
}

@media screen and (max-width: 1440px) {
  .card_bg {
    position:relative;
    padding: 15px;
    text-align: left;
    width: 90vw;
    height: 142px;
    border-radius: 16px;
    overflow: hidden;
  }
}
</style>